import React from 'react';
import PropTypes from 'prop-types';
import {
    TableRow,
    TableRowColumn,
} from 'material-ui/Table';

const getStripedStyle = (index) => {
    if (index % 2) {
        return {};
    }
    return { backgroundColor: '#E0E0E0' };
};

const Row = ({
    item,
    columns,
    index: indexRow,
    onStyleRow,
    ...otherProps
}) => {
    const getValue = (column) => {
        switch (typeof column.name) {
            case 'string':
                return item[column.name];

            case 'function':
                return column.name(item, indexRow);

            default:
                throw new Error('Parâmetro name inválido.');
        }
    };

    return (
        <TableRow style={onStyleRow ? onStyleRow(item) : getStripedStyle(indexRow)} {...otherProps}>
            {
                columns.map((column, index) => (
                    <TableRowColumn
                        // eslint-disable-next-line react/no-array-index-key
                        key={index}
                        style={{
                            whiteSpace: 'normal',
                            wordWrap: 'break-word',
                            padding: 4,
                            width: column.width ? column.width : 'auto',
                            overflow: 'visible',
                        }}
                    >
                        {getValue(column)}
                    </TableRowColumn>
                ))
            }
        </TableRow>
    );
};

Row.propTypes = {
    item: PropTypes.object.isRequired,
    columns: PropTypes.array.isRequired,
    index: PropTypes.number.isRequired,
    onStyleRow: PropTypes.func,
};

Row.defaultProps = {
    onStyleRow: undefined,
};

export default Row;
